import styled from '@emotion/styled';
import {Img} from 'ui';
import {colors, fonts} from 'ui/config';
import playIcon from 'assets/img/picto-play.png';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative',
  marginTop: 17,
  backgroundColor: 'white',
  width: 335,
  height: 261,
});

export const VideoPlaceholder = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'absolute',
});

export const Image = styled(Img)({
  position: 'absolute',
  width: 335,
  height: 200,
  backgroundSize: 'cover',
});

export const PlayIcon = styled('div')({
  position: 'absolute',
  width: 50,
  height: 50,
  backgroundSize: 'cover',
  top: 80,
  backgroundImage: `url(${playIcon})`,
});

export const TitleContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  height: 61,
  backgroundColor: colors.white,
});

export const Title = styled('div')({
  fontSize: 15,
  lineHeight: '19px',
  fontWeight: 'bold',
  color: colors.black,
  fontFamily: fonts.title,
  textAlign: 'left',
});
